"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.448 12.5167C31.1721 13.2171 31.1856 14.366 30.4779 15.0828L17.2779 28.4536C16.933 28.803 16.4602 29 15.9667 29C15.4731 29 15.0004 28.803 14.6554 28.4536L9.52207 23.2538C8.81444 22.5371 8.82785 21.3882 9.55204 20.6878C10.2762 19.9874 11.437 20.0006 12.1446 20.7174L15.9667 24.589L27.8554 12.5464C28.563 11.8296 29.7238 11.8163 30.448 12.5167Z", fill: colour }));
};
//# sourceMappingURL=Tick.js.map